import React, { useState, useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { FaUser, FaLock } from "react-icons/fa";
import { AiFillEye, AiFillEyeInvisible } from "react-icons/ai";
import { AuthContext } from "../context/AuthContext";
import api from "../services/api";
import logo from "../img/logo.png";
import "../styles/login.css";

function LoginPage() {
  const { currentUser, login } = useContext(AuthContext);
  const navigate = useNavigate();

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (currentUser) navigate("/profesores");
  }, [currentUser, navigate]);

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    try {
      const response = await api.post("/auth/token", { username, password });
      const { access_token } = response.data;
      localStorage.setItem("access_token", access_token);
      login(access_token);
      navigate("/profesores");
    } catch (err) {
      setError("Usuario o Contraseña incorrectos.");
    }
  };

  return (
    <div className="login-page">
      <form className="login-box" onSubmit={handleSubmit}>
        <img src={logo} alt="Robotic Minds" className="login-logo" />

        <p>Bienvenido a Dashboard</p>

        <div className="input-wrapper">
          <FaUser className="input-icon" />
          <input
            type="text"
            placeholder="Usuario"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            required
          />
        </div>

        <div className="input-wrapper">
          <FaLock className="input-icon" />
          <input
            type={showPassword ? "text" : "password"}
            placeholder="Contraseña"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
          <span className="toggle-password" onClick={togglePasswordVisibility}>
            {showPassword ? <AiFillEyeInvisible /> : <AiFillEye />}
          </span>
        </div>

        {error && <div className="error-text">{error}</div>}
        <button type="submit" className="btn-submit">Acceder</button>
      </form>
    </div>
  );
}

export default LoginPage;
